import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ExpedienteValidacionComponent from "../../components/expedientesMembresiasValidacion/index";
import {
  ExpedienteValidacionStore,
  expedienteValidacionStore
} from "./ExpedienteValidacion.store";
import {
  ExpedienteValidacionDispatcher,
  expedienteValidacionDispatcher
} from "./ExpedienteValidacion.dispatcher";
import Layout from "../../components/layout";
import { Container } from "reactstrap";

interface Props
  extends ExpedienteValidacionStore,
    ExpedienteValidacionDispatcher {}
interface State {}

@Router()
@ReduxConnect(expedienteValidacionStore, expedienteValidacionDispatcher)
export default class ExpedienteValidacionContainer extends Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Helmet title="Expediente Documentos" />
        <Layout>
          <Container>
            <ExpedienteValidacionComponent {...this.props} />
          </Container>
        </Layout>
      </main>
    );
  }
}
